import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseARAgingResult } from '@hooks/dashboard/useARAging'
import {
  formatCurrency,
  HYGIENE_PLACEHOLDER,
} from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { FinanceMetricTileItem } from '../../FinanceMetricTiles.component'
import { dashboardFinanceMetricFooter } from '../shared/dashboardFinanceMetricFooter'

type ARAgingMetricCardProps = {
  titleHref: string
  arAging: UseARAgingResult
}

export function ARAgingMetricCard({
  titleHref,
  arAging,
}: ARAgingMetricCardProps): React.ReactElement {
  const {
    loading,
    totals,
    hasData,
    hasPayload,
    arAgingBalanceGoalLabel: goalLabel,
  } = arAging
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="AR aging"
      titleHref={titleHref}
      className="dashboard-finance-metric-card"
      loading={pending}
      skeleton={{ metrics: 1, block: 'none' }}
      isEmpty={isEmpty}
    >
      <FinanceMetricTileItem
        leftLabel="AR aging"
        value={
          loading || !totals
            ? HYGIENE_PLACEHOLDER
            : formatCurrency(totals.overdueAR.current, { compact: true })
        }
        rightLabel={goalLabel}
        footer={
          totals ? dashboardFinanceMetricFooter(totals.overdueAR) : undefined
        }
      />
    </DashboardSectionCard>
  )
}
